import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { prettyLetter } from 'pretty-letters';

gsap.registerPlugin(ScrollTrigger);

export default class ParallaxNav {
    constructor(){
        this.section = {
            el: document.getElementById('parallax-nav'),
            topnav: document.querySelector('#parallax-nav .top-nav'),
            lownav: document.querySelector('#parallax-nav .low-nav'),
            links: document.querySelectorAll('#parallax-nav .nav-link'),
        };

        this.links = {
            el: document.querySelector('#parallax-nav .nav-link'),
            letters: document.querySelectorAll('.nav-link [class*="char-"]'),
        };
    }

    init(){
        this.loaded();
    }

    loaded = () => {
        prettyLetters(this.section.links, {
            charClass: 'char-',
            groupClass: 'word-',
            charTag: 'span',
            groupTag: 'span',
        });

        gsap.from('.nav-link [class*="char-"]', .5,{
            y: 200,
            autoAlpha: 0,
            stagger: .05,
            ease: 'expo.easeInOut',
            scrollTrigger: {
                trigger: this.section.topnav,
                start: 'top center',
                end: 'bottom center',
            }
        });

        gsap.fromTo(this.section.topnav, 2,{
            x: 250,
        },{
            x: -100,
            scrollTrigger: {
                trigger: this.section.topnav,
                start: 'top bottom',
                end: 'bottom top',
                scrub: .3,
            }
        });

        gsap.fromTo(this.section.lownav, 2,{
            x: -250,
        },{
            x: 100,
            scrollTrigger: {
                trigger: this.section.lownav,
                start: 'top bottom',
                end: 'bottom top',
                scrub: .3
            }
        });
    }
}
